import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/svg/vip.svg';
const _withScopeId = n => (_pushScopeId("data-v-1de80324"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "个人中心")], -1));
const _hoisted_3 = {
  class: "text-center"
};
const _hoisted_4 = {
  class: "list-group"
};
const _hoisted_5 = {
  class: "list-group-item list-group-striped"
};
const _hoisted_6 = {
  class: "oneLine"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-style"
}, "用户名", -1));
const _hoisted_8 = {
  class: "pull-right"
};
const _hoisted_9 = {
  class: "list-group-item"
};
const _hoisted_10 = {
  class: "oneLine"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "font-style"
}, "用户昵称", -1));
const _hoisted_12 = {
  class: "pull-right"
};
const _hoisted_13 = {
  class: "list-group-item"
};
const _hoisted_14 = {
  class: "oneLine"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "手机号码", -1));
const _hoisted_16 = {
  class: "pull-right"
};
const _hoisted_17 = {
  class: "list-group-item"
};
const _hoisted_18 = {
  class: "oneLine"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "邮箱", -1));
const _hoisted_20 = {
  class: "pull-right"
};
const _hoisted_21 = {
  class: "list-group-item"
};
const _hoisted_22 = {
  class: "oneLine"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "创建日期", -1));
const _hoisted_24 = {
  class: "pull-right"
};
const _hoisted_25 = {
  class: "list-group-item"
};
const _hoisted_26 = {
  class: "oneLine"
};
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会员等级", -1));
const _hoisted_28 = {
  class: "pull-right"
};
const _hoisted_29 = {
  key: 0,
  src: _imports_0,
  style: {
    "width": "16px",
    "height": "16px",
    "margin-right": "3px"
  }
};
const _hoisted_30 = {
  style: {
    "font-family": "'Harmony Font'",
    "font-size": "16px"
  }
};
const _hoisted_31 = {
  key: 0,
  class: "list-group-item"
};
const _hoisted_32 = {
  class: "oneLine"
};
const _hoisted_33 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "会员有效期", -1));
const _hoisted_34 = {
  class: "pull-right"
};
const _hoisted_35 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "card-header"
}, [/*#__PURE__*/_createElementVNode("span", null, "基本资料")], -1));
import UserAvatar from "../components/user/UserAvator.vue";
import { onMounted, ref } from "vue";
import { useLoginUserStore } from "@/store/loginUser";
import UserInfo from "@/components/user/UserInfo.vue";
import ResetPwd from "@/components/user/ResetPwd.vue";
import { useRouter } from "vue-router";
import ACCESS_ENUM from '@/access/ACCESS_ENUM.ts';
import { SysDictDataControllerService } from "../../generated";
export default /*#__PURE__*/_defineComponent({
  __name: 'PersonView',
  setup(__props) {
    const activeTab = ref('userinfo');
    const useLoginUser = useLoginUserStore();
    const memberPeriodDict = ref([]);
    const router = useRouter();
    const clearQueryParams = () => {
      // 获取当前路由的路径和查询参数
      const {
        fullPath
      } = router.currentRoute.value;
      // 通过分割路径和查询参数来清除查询参数
      const cleanPath = fullPath.split('?')[0];
      // 使用 Vue Router 替换当前路由 URL，不带查询参数
      router.replace({
        path: cleanPath
      });
    };
    //获取字典数据
    const getSysDicType = async dicType => {
      //获取字典数据
      const res = await SysDictDataControllerService.dictTypeUsingGet(dicType);
      return res;
    };
    //获取会员字典信息
    const getMemberDictInfo = async () => {
      const res = await getSysDicType('member_period');
      if (res.code === 200) {
        memberPeriodDict.value = res.data;
      }
    };
    onMounted(() => {
      //清理浏览器的参数
      clearQueryParams();
      //获取会员字典数据
      getMemberDictInfo();
    });
    return (_ctx, _cache) => {
      const _component_UserFilled = _resolveComponent("UserFilled");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_Iphone = _resolveComponent("Iphone");
      const _component_Message = _resolveComponent("Message");
      const _component_Calendar = _resolveComponent("Calendar");
      const _component_CreditCard = _resolveComponent("CreditCard");
      const _component_dict_tag = _resolveComponent("dict-tag");
      const _component_el_card = _resolveComponent("el-card");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_tab_pane = _resolveComponent("el-tab-pane");
      const _component_el_tabs = _resolveComponent("el-tabs");
      const _component_el_row = _resolveComponent("el-row");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
        gutter: 20
      }, {
        default: _withCtx(() => [_createVNode(_component_el_col, {
          sm: 24,
          md: 7,
          style: {
            "transition": "all .5s ease-out",
            "margin-bottom": "30px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, {
            class: "box-card"
          }, {
            header: _withCtx(() => [_hoisted_2]),
            default: _withCtx(() => [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_3, [_createVNode(UserAvatar)]), _createElementVNode("ul", _hoisted_4, [_createElementVNode("li", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_UserFilled)]),
              _: 1
            }), _hoisted_7, _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(useLoginUser).loginUser.userName), 1)])]), _createElementVNode("li", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_UserFilled)]),
              _: 1
            }), _hoisted_11, _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(useLoginUser).loginUser.nickName), 1)])]), _createElementVNode("li", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_Iphone)]),
              _: 1
            }), _hoisted_15, _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(useLoginUser).loginUser.phonenumber), 1)])]), _createElementVNode("li", _hoisted_17, [_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_Message)]),
              _: 1
            }), _hoisted_19, _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(useLoginUser).loginUser.email), 1)])]), _createElementVNode("li", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_Calendar)]),
              _: 1
            }), _hoisted_23, _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(useLoginUser).loginUser.createTime), 1)])]), _createElementVNode("li", _hoisted_25, [_createElementVNode("div", _hoisted_26, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_CreditCard)]),
              _: 1
            }), _hoisted_27, _createElementVNode("div", _hoisted_28, [!(_unref(useLoginUser).loginUser?.userRole === _unref(ACCESS_ENUM).NOT_LOGIN || _unref(useLoginUser).loginUser?.userRole === _unref(ACCESS_ENUM).USER) ? (_openBlock(), _createElementBlock("img", _hoisted_29)) : _createCommentVNode("", true), _createElementVNode("span", _hoisted_30, _toDisplayString(_unref(useLoginUser).loginUser.userRole), 1)])])]), !(_unref(useLoginUser).loginUser?.userRole === _unref(ACCESS_ENUM).NOT_LOGIN || _unref(useLoginUser).loginUser?.userRole === _unref(ACCESS_ENUM).USER) ? (_openBlock(), _createElementBlock("li", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createVNode(_component_el_icon, {
              class: "icon-item"
            }, {
              default: _withCtx(() => [_createVNode(_component_CreditCard)]),
              _: 1
            }), _hoisted_33, _createElementVNode("div", _hoisted_34, [memberPeriodDict.value.length ? (_openBlock(), _createBlock(_component_dict_tag, {
              key: 0,
              "color-type": 2,
              "dict-list": memberPeriodDict.value,
              "dic-value": _unref(useLoginUser).loginUser?.memberPeriod
            }, null, 8, ["dict-list", "dic-value"])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true)])])]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_el_col, {
          sm: 24,
          md: 17
        }, {
          default: _withCtx(() => [_createVNode(_component_el_card, null, {
            header: _withCtx(() => [_hoisted_35]),
            default: _withCtx(() => [_createVNode(_component_el_tabs, {
              modelValue: activeTab.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeTab.value = $event)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
                label: "基本资料",
                name: "userinfo"
              }, {
                default: _withCtx(() => [_createVNode(UserInfo, {
                  user: _unref(useLoginUser).loginUser
                }, null, 8, ["user"])]),
                _: 1
              }), _createVNode(_component_el_tab_pane, {
                label: "修改密码",
                name: "resetPwd"
              }, {
                default: _withCtx(() => [_createVNode(ResetPwd)]),
                _: 1
              })]),
              _: 1
            }, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
});